export default {
  reason:
    "The username you entered is not associated to this practice. Close the window, verify your credentials, and then try again.",
  close: "Close this window",
};
